import { jsx as _jsx } from "react/jsx-runtime";
const base = "inline-flex items-center justify-center gap-2 h-10 min-w-[40px] px-3.5 rounded-lg text-[13px] font-medium transition-colors duration-150 select-none";
const variants = {
    ghost: "text-hc-ink/85 hover:text-hc-ink hover:bg-white/[0.06] active:bg-white/[0.10]",
    primary: "bg-hc-accent text-white hover:bg-hc-accent/90 active:bg-hc-accent/95",
    danger: "text-hc-bad hover:bg-hc-bad/12 active:bg-hc-bad/18",
};
const activeClass = "bg-hc-accent/15 text-hc-ink ring-1 ring-inset ring-hc-accent/40";
const cn = (...parts) => parts.filter(Boolean).join(" ");
export const ToolbarButton = ({ children, active, variant = "ghost", className, ...rest }) => (_jsx("button", { type: "button", ...rest, className: cn(base, active ? activeClass : variants[variant], className), children: children }));
//# sourceMappingURL=ToolbarButton.js.map